import * as action_types from "./constants";

const initialState = {
  managersList: {
    // count: 0,
    // results: [],
  },
  allManagers:[]
};

export default (state = initialState, action) => {
  const { type, data } = action;
  switch (type) {
    case action_types.GET_MANAGERS:
      return { ...state, managersList: data };
    case action_types.GET_ALL_MANAGERS:
      return { ...state, allManagers: data };
    case action_types.EMPTY_MANAGERS:
      return { ...state, managersList: data };
    default:
      return state;
  }
};
